import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Grid, GridItem, HStack, Text, useBreakpointValue, } from '@chakra-ui/react';
import { chakraSpacingUnit, defaultFontFamily } from '@client/theme';
import { useState } from 'react';
import { FaImages } from 'react-icons/fa6';
import { AppImage } from './AppImage';
import { LightBox } from './LightBox';
const COLLAGE_HEIGHT = 450;
const COLLAGE_GAP = 3;
const COLLAGE_GAP_PX = COLLAGE_GAP * chakraSpacingUnit;
export const THUMBNAIL_ROWS = 2;
const THUMBNAIL_HEIGHT = (COLLAGE_HEIGHT - COLLAGE_GAP_PX * (THUMBNAIL_ROWS - 1)) /
    THUMBNAIL_ROWS;
export const THUMBNAIL_COLUMNS_BY_BREAKPOINT = {
    base: 1,
    lg: 2,
};
export const collageGridProps = (aspectRatio, numThumbnailColumns) => ({
    w: 'fit-content',
    mx: 'auto',
    gap: COLLAGE_GAP,
    gridTemplateRows: `repeat(${THUMBNAIL_ROWS}, ${THUMBNAIL_HEIGHT}px)`,
    gridTemplateColumns: `${COLLAGE_HEIGHT * aspectRatio}px repeat(${numThumbnailColumns}, ${THUMBNAIL_HEIGHT * aspectRatio}px)`,
});
export const ImageCollage = (props) => {
    const numThumbnailColumns = useBreakpointValue(THUMBNAIL_COLUMNS_BY_BREAKPOINT, {
        ssr: false,
    }) ?? 1;
    const [lightBoxPage, setLightBoxPage] = useState(null);
    const numThumbnails = Math.min(numThumbnailColumns * THUMBNAIL_ROWS, props.urls.length - 1);
    const numHiddenImages = props.urls.length - 1 - numThumbnails;
    const numThumbnailColumnsUsed = Math.ceil(numThumbnails / THUMBNAIL_ROWS);
    const renderTile = (index) => (_jsxs(Box, { position: "relative", height: "100%", children: [_jsx(AppImage, { aspectRatio: props.aspectRatio, imageProps: {
                    src: props.urls[index],
                    loading: index === 0 ? undefined : 'lazy',
                    onClick: () => setLightBoxPage(index),
                    borderRadius: 5,
                    cursor: 'button',
                    height: '100%',
                    aspectRatio: 'auto',
                }, containerProps: {
                    height: '100%',
                    borderRadius: 'md',
                } }), numHiddenImages > 0 && index === numThumbnails && (_jsxs(HStack, { position: "absolute", inset: 0, justifyContent: "center", bg: "blackAlpha.600", color: "white", borderRadius: "md", cursor: "button", fontFamily: defaultFontFamily, fontSize: 24, onClick: () => setLightBoxPage(index), children: [_jsx(FaImages, {}), _jsxs(Text, { children: ["+", numHiddenImages, " image", numHiddenImages > 1 ? 's' : ''] })] }))] }));
    return (_jsxs(_Fragment, { children: [_jsx(LightBox, { ...props, page: lightBoxPage, setPage: setLightBoxPage }), _jsxs(Grid, { ...collageGridProps(props.aspectRatio, numThumbnailColumnsUsed), children: [_jsx(GridItem, { rowSpan: THUMBNAIL_ROWS, children: renderTile(0) }), Array.from({ length: numThumbnails }, (_, i) => i + 1).map((index) => (_jsx(GridItem, { children: renderTile(index) }, props.urls[index])))] })] }));
};
